import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "m17.594 19.98 3.394-16.325a.543.543 0 0 0-.727-.618L1.348 10.334a.543.543 0 0 0 .005 1.016l4.609 1.72 1.783 5.736a.542.542 0 0 0 .862.26l2.569-2.095c.27-.22.653-.23.934-.026l4.633 3.364c.32.232.771.057.851-.328ZM7.458 12.155l9.006-5.547c.162-.1.329.12.19.248l-7.433 6.91c-.262.243-.43.568-.478.921l-.253 1.877c-.034.25-.386.275-.455.033l-.974-3.422a.907.907 0 0 1 .397-1.02Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }